
import React, { useState, useEffect, useRef } from "react";
// import Header from "../common/components/Header";
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import CateringAdvertisements from "./CateringAdvertisements";
import { Link } from 'react-router-dom';
import CateringOffers from "./CateringOffers";
const cateringOffers = [
  {
    id: 1,
    gole: "Buffet Lunch",
    description: "Enjoy unlimited buffet with 20% off!",
    couponCode: "BUFFET20",
    startDate: "2025-09-01",
    endDate: "2025-09-30",
    discountPercentage: 20,
    offerType: "buffet",
  },
  {
    id: 2,
    gole: "Wedding Package",
    description: "Flat 15% off on wedding catering bookings.",
    couponCode: "WED15",
    startDate: "2025-09-10",
    endDate: "2025-12-31",
    discountPercentage: 15,
    offerType: "wedding",
  },
  {
    id: 3,
    gole: "Birthday Special",
    description: "Book birthday catering & get 1kg cake free 🎂",
    couponCode: "BIRTHDAYFREE",
    startDate: "2025-09-05",
    endDate: "2025-11-30",
    discountPercentage: 10,
    offerType: "birthday",
  },
  {
    id: 4,
    gole: "Corporate Lunch",
    description: "Get 25% off on corporate lunch packages.",
    couponCode: "CORP25",
    startDate: "2025-09-01",
    endDate: "2025-10-31",
    discountPercentage: 25,
    offerType: "corporate",
  },
];
const Promotions = () => {
  // const [activeCategory, setActiveCategory] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [parentId, setParentId] = useState(null);
  // const [activeCategory, setActiveCategory] = useState("Allitems");
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [isVegSelected, setIsVegSelected] = useState(false);
  const [isNonVegSelected, setIsNonVegSelected] = useState(false);
  // const [quantities, setQuantities] = useState({});
  const [quantities, setQuantities] = useState({}); // Track quantities of items
  const [showPopup, setShowPopup] = useState(false);
  const [popupItem, setPopupItem] = useState(null);
  const [items, setItems] = useState([]); // Store API data
  // const [quantities, setQuantities] = useState({}); // Manage quantity state
  const [categories, setCategories] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const [dishes, setDishes] = useState([]);  // Added state for dishes
  const location = useLocation();
  const [posts, setPosts] = useState([]);
  const [activeCategory, setActiveCategory] = useState("overview");
  const isMobile = window.innerWidth <= 768;



  const [isPaused, setIsPaused] = useState(false);

  const toggleCard = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };
  const [expandedCard, setExpandedCard] = useState(null); // ✅ expand state

  useEffect(() => {
    if (location.state?.activeCategory === 'Payments') {
      setActiveCategory('Payments');
    }
  }, [location]);

  useEffect(() => {
    if (location.state?.activeCategory === 'Profile') {
      setActiveCategory('Profile');
    }
  }, [location]);

  useEffect(() => {
    if (location.state?.activeCategory === 'Notifications') {
      setActiveCategory('Notifications');
    }
  }, [location]);
  // Function to handle card click and set the active category
  const handleClick = (category) => {
    setActiveCategory(category);
  };
  const navigate = useNavigate();


  const iconMap = {
    overview: "",
    All: "",
    Pending: "",
    Closed: "",
    Cancelled: "",
  };








  // Automatically activate the first item from backend data
  useEffect(() => {
    if (categories.length > 0) {
      setActiveCategory("Allitems"); // Default to "Allitems"
    }
  }, [categories]);






  // Functions for quantity handling

  // const handleClick = (category) => {
  //     setActiveCategory(category);
  //     setIsVegSelected(false);
  //     setIsNonVegSelected(false);
  // };

  const handleFilterClick = (type) => {
    if (type === "Veg") {
      setIsVegSelected(true);
      setIsNonVegSelected(false);
    } else if (type === "Non-veg") {
      setIsNonVegSelected(true);
      setIsVegSelected(false);
    } else {
      setIsVegSelected(false);
      setIsNonVegSelected(false);
    }
  };



  // const categories = {


  // };

  const currentCategoryItems = categories[activeCategory] || [];

  const filteredItems = currentCategoryItems.filter((item) => {
    if (isVegSelected) return item.type === "Veg";
    if (isNonVegSelected) return item.type === "Non-veg";
    return true;
  });

  const addToCarts = (id) => {
    setQuantities((prev) => ({ ...prev, [id]: 1 })); // Set initial quantity to 1
    setPopupItem(filteredItems.find((item) => item.id === id)); // Store clicked item
    setShowPopup(true);
  };

  const increaseQuantity = (id) => {
    setQuantities((prev) => ({ ...prev, [id]: (prev[id] || 0) + 1 }));
  };

  const decreaseQuantity = (id) => {
    setQuantities((prev) => {
      const newQuantity = (prev[id] || 0) - 1;
      if (newQuantity <= 0) {
        const updatedQuantities = { ...prev };
        delete updatedQuantities[id]; // Remove item if quantity is 0
        return updatedQuantities;
      }
      return { ...prev, [id]: newQuantity };
    });
  };


  const scrollContainerRef = useRef(null);


  const addToCart = async (item, quantity = 1) => {
    console.log('addToCart called with dishId:', item.dishId);

    const apiUrl = `http://10.10.20.9:7007/Mamaswebsite-0.0.1-SNAPSHOT/cart/add/1`;

    const data = {
      dishId: item.dishId,
      quantity: quantity,
      price: (item.price * 0.9).toFixed(2)
    };

    try {
      const response = await axios.post(apiUrl, data, {
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.status === 200) {
        console.log('Item successfully added to cart:', response.data);
        alert('Item added to cart successfully!');
        navigate('/maamaascart');
      } else {
        console.error('Failed to add item to cart:', response.data);
        alert('Failed to add item to cart. Please try again.');
      }
    } catch (error) {
      console.error('Error adding item to cart:', error);

      if (error.response) {
        console.error('Server Response:', error.response.data);

        if (error.response.status === 500) {
          alert('Server Error: There’s an issue with the backend. Please try again later.');
        } else if (error.response.status === 404) {
          alert('Item not found. Please try again.');
        } else {
          alert(`Error: ${error.response.data}`);
        }
      } else {
        alert('An unexpected error occurred. Please try again.');
      }
    }
  };


  useEffect(() => {
    axios.get('http://10.10.20.9:7007/Mamaswebsite-0.0.1-SNAPSHOT/dish/getall')
      .then((response) => {
        const allDishes = response.data;

        // Filter for dishes with the name "Combos"
        const combos = allDishes.filter(dish => dish.dishName === "Combos");

        // Find child dishes with matching parentId
        const filteredData = allDishes.filter(dish =>
          combos.some(combo => combo.dishId === dish.parentId)
        );

        setPosts(filteredData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);



  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    let interval;

    const startScrolling = () => {
      interval = setInterval(() => {
        if (!isHovered) {
          scrollContainer.scrollTop += 1; // Scroll down smoothly

          // Infinite loop logic
          if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
            scrollContainer.scrollTop = 0; // Reset to top for seamless loop
          }
        }
      }, 20); // Adjust speed by changing interval
    };

    startScrolling();

    return () => clearInterval(interval);
  }, [isHovered]);
  const scrollRef = useRef(null);
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    let scrollInterval;

    if (scrollContainer && !isPaused) {
      scrollInterval = setInterval(() => {
        if (
          scrollContainer.scrollTop + scrollContainer.clientHeight >=
          scrollContainer.scrollHeight
        ) {
          scrollContainer.scrollTop = 0;
        } else {
          scrollContainer.scrollTop += 1; // scroll speed
        }
      }, 50);
    }

    return () => clearInterval(scrollInterval);
  }, [isPaused]); // pause state control karega


  const getOfferColor = (type) => {
    switch (type) {
      case "buffet":
        return "#ff6f61";
      case "wedding":
        return "#6a5acd";
      case "birthday":
        return "#ffb347";
      case "corporate":
        return "#2e8b57";
      default:
        return "#333";
    }
  };





  return (
    <>
      <div className="container-fluid">
        <div className="row" style={{ marginTop: "40px" }}>

          {/* Left Column - Scrollable Category List */}
          <div className="col-lg-2 col-md-2 col-sm-2 col-2">
            <div
              style={{
                maxHeight: "600px",
                position: "fixed",
                top: "50px",
                marginTop: "5px",
                zIndex: 1000,
                width: "180px",
                scrollbarWidth: "none",
                msOverflowStyle: "none",

              }}
            >

              <div className="category-container" style={{
                overflowY: "auto",
                height: "540px",
                marginTop: "68px",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}>
                {/* Category Cards */}
                {[].map(
                  (category, index) => (
                    <div
                      key={index}
                      className="category-card"
                      onClick={() => handleClick(category)}
                      style={{
                        backgroundColor: activeCategory === category ? "rgb(177 93 198)" : "#D9D9D9",
                        margin: "8px 0",
                        padding: "10px",
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                        cursor: "pointer",
                        justifyContent: "center",
                        borderRadius: "15px",
                        transition: "0.3s ease-in-out",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      {/* Icon inside a fixed-size wrapper */}


                      <div style={{ fontSize: "20px", fontWeight: "bold" }} className="category-card-body d-flex justify-content-center p-0">
                        {category}
                      </div>
                    </div>
                  )
                )}
              </div>

            </div>
          </div>

          {/* Right Column - Content Based on Active Category */}
          <div className="col-lg-7 col-md-7 col-sm-7 col-7 cartdta-mobile" style={{ paddingLeft: "0px", paddingRight: "0px" }}  >


            <p
              className="breadcrumb maamaas-home-bredcum"
              style={{
                position: "fixed",
                top: isMobile ? "50px" : "80px",
                left: isMobile ? "5px" : "275px",
                width: "100%",
                backgroundColor: "#fff",
                zIndex: 1000,
                padding: "10px 0",
                fontSize: isMobile ? "14px" : "18px",
                fontWeight: isMobile ? "normal" : "bold",
                textAlign: "center",
                margin: 0,
              }}
            >
              <Link
                to="/Newmainlandingpage"
                style={{
                  color: "purple",
                  fontWeight: "bold",
                  textDecoration: "none",
                }}
              >
                Home
              </Link>

              <span className="separator"> &gt; </span>
              <Link
                to="/Catreingpromotion"
                style={{
                  color: "purple",
                  fontWeight: "bold",
                  textDecoration: "none",
                }}
              >
                promotions
              </Link>

            </p>

            <div
              style={{
                marginTop: "20px",
                padding: "20px",
                // backgroundColor: "#f1f1f1",
                borderRadius: "8px",
              }}
            >
              {/* Show different details based on active category */}
              {activeCategory === "overview" && (
                <div>
                  {/* <h3>Cart Details</h3> */}
                  <CateringOffers />
                </div>
              )}


            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div>
            <CateringAdvertisements />
          </div>
        </div>

      </div>



    </>
  );
};

export default Promotions;
